import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const CountryCard = ({ country, large = false, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
  >
    <Link
      to={`/countries/${country.slug}`}
      data-testid={`country-card-${country.slug}`}
      className={`group block bg-white rounded-2xl overflow-hidden border border-pine/10 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300 ${
        large ? "md:col-span-2" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${large ? "h-64 md:h-80" : "h-52"}`}>
        <img
          src={country.image}
          alt={country.imageAlt}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-pine-ink/70 via-transparent to-transparent" />
        <div className="absolute bottom-4 left-5 right-5 flex items-end justify-between">
          <div>
            <p className="inline-block font-mono text-[10px] tracking-[0.25em] font-semibold text-ink bg-cream/90 rounded-full px-2.5 py-1 uppercase mb-1.5">{country.region}</p>
            <h3 className="font-serif font-semibold text-2xl md:text-3xl text-cream">
              {country.name}
            </h3>
          </div>
          <span className="w-10 h-10 rounded-full bg-cream/15 backdrop-blur flex items-center justify-center text-cream transition-all duration-300 group-hover:bg-petal group-hover:rotate-45">
            <ArrowUpRight size={18} />
          </span>
        </div>
      </div>
      <div className="p-5 md:p-6">
        <p className="font-serif italic text-lg text-sage">{country.tagline}</p>
        <div className="mt-4 flex flex-wrap gap-2">
          <span className="text-xs font-mono px-2.5 py-1 rounded-full bg-blush text-petal-dark">{country.quickFacts.currency.split("(")[0].trim()}</span>
          <span className="text-xs font-mono px-2.5 py-1 rounded-full bg-pine/5 text-pine">{country.quickFacts.climate.split(",")[0]}</span>
          <span className="text-xs font-mono px-2.5 py-1 rounded-full bg-pine/5 text-pine">{country.quickFacts.muslimPercent} Muslim</span>
        </div>
        <div className="mt-4 flex items-center justify-end border-t border-pine/10 pt-4">
          <span className="text-xs font-semibold tracking-wide text-pine group-hover:text-petal transition-colors">
            READ PROFILE & MOM'S TAKE →
          </span>
        </div>
      </div>
    </Link>
  </motion.div>
);
